import {useTranslation} from "react-i18next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import axiApi from "ApiCaller";
import {SwalAlertClass} from "core/swalClass";
import Form from "react-bootstrap/Form";
import {useEffect, useState} from "react";
import FormButton from "components/buttons/FormButton";
import useCustomTranslation from "core/customTranslation";
import {translations} from "../translations";

const PrevConfig = ({
    item,
    items,
    onClickDelete,
    setItemsShown,
    showPreview,
    models,
    ships,
    sensors,
    alerts,
    isSuperUser,
    setShowPreview,
}) => {
    const {t: _Tf} = useTranslation("forms");
    const {t: _Tc} = useCustomTranslation(translations);
    const Alert = new SwalAlertClass({confirmButtonText: _Tf("labels.accept")});
    const [formData, setFormData] = useState({
        id: item.id || "",
        name: item.name || "",
        description: item.description || "",
        default: item.default || "",
        model: item.model || "",
        ships_id: item.ships_id || "",
        sensors_id: item.sensors_id || "",
        alerts_id: item.alerts_id || "",
    });
    const [modelsWithShips, setModelsWithShips] = useState([]);
    const [modelsWithSensors, setModelsWithSensors] = useState([]);
    const [modelsWithAlerts, setModelsWithAlerts] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const ships_ = ships.filter((ship) => ship.model === formData.model);
        const sensors_ = sensors.filter((sensor) => sensor.model === formData.model);
        const alerts_ = alerts.filter((alert) => alert.model === formData.model);

        setModelsWithShips(ships_);
        setModelsWithSensors(sensors_);
        setModelsWithAlerts(alerts_);

        setFormData({...item});
    }, [item]);

    const handleChange = (e) => {
        const {name, value, type, checked} = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const clickDelete = () => {
        if (formData.id) {
            onClickDelete(formData.id);
        }
    };
    const handleCancel = () => {
        setShowPreview(false);
    };

    const onSubmit = (e) => {
        setIsLoading(true);
        e.preventDefault();

        const form = new FormData(e.currentTarget);
        // for (let [key, value] of form.entries()) {
        //     console.log(`${key}: ${value}`);
        // }

        axiApi
            .post("/api/devices/config/", form)
            .then((resp) => {
                if (resp.data.status) {
                    const updatedItem = resp.data.item;
                    const isUpdate = resp.data.update;

                    if (isUpdate) {
                        items.current.showed = items.current.showed.map((currentItem) => {
                            if (currentItem.id === updatedItem.id) {
                                return updatedItem;
                            }
                            if (
                                currentItem.model === updatedItem.model &&
                                updatedItem.default &&
                                currentItem.id !== updatedItem.id
                            ) {
                                return {...currentItem, default: false};
                            }
                            return currentItem;
                        });
                    } else {
                        if (updatedItem.default) {
                            items.current.all = items.current.all.map((currentItem) => {
                                if (currentItem.model === updatedItem.model) {
                                    return {...currentItem, default: false};
                                }
                                return currentItem;
                            });

                            items.current.showed = items.current.showed.map((currentItem) => {
                                if (currentItem.model === updatedItem.model) {
                                    return {...currentItem, default: false};
                                }
                                return currentItem;
                            });
                        }
                        items.current.all.push(updatedItem);
                        items.current.showed.push(updatedItem);
                    }

                    setItemsShown([...items.current.showed]);

                    Alert.success(_Tc("message.success.title"), _Tc("message.success.text"));
                }
            })
            .catch((error) => {
                console.error("Error al enviar la solicitud:", error);
            })
            .finally(() => {
                setIsLoading(false);
                setShowPreview(false);
            });
    };

    return (
        <div className={`col-md col-12 preview-row ${showPreview ? "" : "d-none"}`} style={{width: "300px", maxWidth: "300px"}}>
            <div className="row">
                <div className="col-12 p-0">
                    <Form onSubmit={onSubmit} className="preview-card" style={{width: "300px"}}>
                        <input type="hidden" id="id" name="id" value={formData.id} />
                        <div className="preview-header">
                            <div className="preview-icon">
                                <FontAwesomeIcon icon="gear" />
                            </div>
                            <div className="preview-title">
                                <label>{_Tc("preview.title")}</label>
                                <div>{formData.name}</div>
                            </div>
                        </div>
                        <div className="p-2">
                            <div className="preview-item">
                                <label>{_Tf("common.name")}</label>
                                <input
                                    type="text"
                                    className="form-control mb-2"
                                    id="name"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="preview-item">
                                <label>{_Tf("common.description")}</label>
                                <textarea
                                    className="form-control mb-2"
                                    id="description"
                                    name="description"
                                    value={formData.description}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="preview-item mt-4 d-flex justify-content-center">
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="default"
                                        name="default"
                                        checked={formData.default}
                                        onChange={handleChange}
                                    />
                                    <label className="form-check-label" htmlFor="default">
                                        {_Tc("field.default")}
                                    </label>
                                </div>
                            </div>
                            <div className="preview-item mt-2">
                                <label>{_Tc("field.model")}</label>
                                <Form.Select
                                    className="mb-2"
                                    id="model"
                                    name="model"
                                    value={formData.model}
                                    onChange={handleChange}
                                    required>
                                    {models.map((model_, idx) => (
                                        <option key={idx} value={model_}>
                                            {model_}
                                        </option>
                                    ))}
                                </Form.Select>
                            </div>
                            <div className="preview-item">
                                <label>{_Tc("field.measurement")}</label>
                                <Form.Select
                                    className="mb-2"
                                    id="ships_id"
                                    name="ships_id"
                                    value={formData.ships_id}
                                    onChange={handleChange}
                                    required>
                                    {modelsWithShips.map((ship) => (
                                        <option key={ship.id} value={ship.id}>
                                            {`${ship.name} (${ship.model})`}
                                        </option>
                                    ))}
                                </Form.Select>
                            </div>
                            <div className="preview-item">
                                <label>{_Tc("field.sensors")}</label>
                                <Form.Select
                                    className="mb-2"
                                    id="sensors_id"
                                    name="sensors_id"
                                    value={formData.sensors_id}
                                    onChange={handleChange}>
                                    {modelsWithSensors.map((sensor) => (
                                        <option key={sensor.id} value={sensor.id}>
                                            {sensor.name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </div>
                            <div className="preview-item">
                                <label>{_Tc("field.alerts")}</label>
                                <Form.Select
                                    className="mb-2"
                                    id="alerts_id"
                                    name="alerts_id"
                                    value={formData.alerts_id}
                                    onChange={handleChange}>
                                    {modelsWithAlerts.map((alert) => (
                                        <option key={alert.id} value={alert.id}>
                                            {alert.name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </div>
                        </div>
                        <div className="row mt-3">
                            <hr />
                            <div className="col-12 d-flex justify-content-between">
                                <button type="button" className="btn btn-danger" disabled={!isSuperUser} onClick={clickDelete}>
                                    <FontAwesomeIcon icon="trash" className="text-white" />
                                </button>
                                <div>
                                    <button type="button" className="btn btn-secondary" onClick={handleCancel}>
                                        {_Tc("button.cancel")}
                                    </button>
                                    <FormButton
                                        type="submit"
                                        className="btn btn-primary ms-2"
                                        disabled={!isSuperUser || !formData.model || !formData.ships_id}
                                        isProcessing={isLoading}>
                                        {_Tc("button.save")}
                                    </FormButton>
                                </div>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        </div>
    );
};

export default PrevConfig;
